import { render, staticRenderFns } from "./Basecard.vue?vue&type=template&id=262ba5e8&"
import script from "./Basecard.vue?vue&type=script&lang=js&"
export * from "./Basecard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/eyupt/Desktop/Projects/asfarma/wwwasfarma/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
